import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MyHead from '../../components/MyHead';

import Image from 'next/future/image';
import { entries, map, orderBy, sortBy } from 'lodash';
import StaticPagesCards from '@/components/v2/StaticPagesCards';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation } from 'swiper';

const AwardsPage: React.FC = () => {
  const { t } = useTranslation();

  const awards = useMemo(
    () => ({
      2024: [
        {
          title: t('P_AWARDS.CARDS2024.CARD-1.TITLE'),
          src: '/v2/awards/2024/dia2024.png'
        },
        {
          title: t('P_AWARDS.CARDS2024.CARD-2.TITLE'),
          src: '/v2/awards/2024/logo_aw.png'
        }
      ],
      2023: [
        {
          title: t('P_AWARDS.CARDS2023.CARD-1.TITLE'),
          src: '/v2/awards/2023/VictoryBikeShirt.png'
        },
        {
          title: t('P_AWARDS.CARDS2023.CARD-2.TITLE'),
          src: '/v2/awards/2023/BiotechBaselayer.png'
        },
        {
          title: t('P_AWARDS.CARDS2023.CARD-3.TITLE'),
          src: '/v2/awards/2023/NakedCarbonMTBShoes.png'
        },
        {
          title: t('P_AWARDS.CARDS2024.CARD-3.TITLE'),
          src: '/v2/awards/2024/European_Product_Design_Award.png'
        },
        {
          title: t('P_AWARDS.CARDS2024.CARD-4.TITLE'),
          src: '/v2/awards/2024/ADI_Design_Index.png'
        }
      ],
      2022: [
        {
          title: t('P_AWARDS.CARDS2022.CARD-1.TITLE'),
          src: '/v2/awards/2022/EvolutyonBiotechUnderwear.png'
        },
        {
          title: t('P_AWARDS.CARDS2022.CARD-2.TITLE'),
          src: '/v2/awards/2022/top3.png'
        },
        {
          title: t('P_AWARDS.CARDS2022.CARD-3.TITLE'),
          src: '/v2/awards/2022/UYNManFutureJacket.png'
        },
        {
          title: t('P_AWARDS.CARDS2022.CARD-4.TITLE'),
          src: '/v2/awards/2022/UYNRunnerFive.png'
        },
        {
          title: t('P_AWARDS.CARDS2022.CARD-5.TITLE'),
          src: '/v2/awards/2022/CommunityMask.png'
        },
        {
          title: t('P_AWARDS.CARDS2022.CARD-6.TITLE'),
          src: '/v2/awards/2022/UYNUltra1.png'
        },
        {
          title: t('P_AWARDS.CARDS2022.CARD-7.TITLE'),
          src: '/v2/awards/2022/DashTune.png'
        },
        {
          title: t('P_AWARDS.CARDS2022.CARD-8.TITLE'),
          src: '/v2/awards/2022/Committed.png'
        }
      ],
      2021: [
        {
          title: t('P_AWARDS.CARDS2021.CARD-1.TITLE'),
          src: '/v2/awards/2021/UynAirwingCycling.png'
        },
        {
          title: t('P_AWARDS.CARDS2021.CARD-2.TITLE'),
          src: '/v2/awards/2021/UYNSabot.png'
        },
        {
          title: t('P_AWARDS.CARDS2021.CARD-3.TITLE'),
          src: '/v2/awards/2021/ResilyonUnderwear.png'
        },
        {
          title: t('P_AWARDS.CARDS2021.CARD-4.TITLE'),
          src: '/v2/awards/2021/GermanInnovation.png'
        },
        {
          title: t('P_AWARDS.CARDS2021.CARD-5.TITLE'),
          src: '/v2/awards/2021/GlobalFootwear.png'
        },
        {
          title: t('P_AWARDS.CARDS2021.CARD-6.TITLE'),
          src: '/v2/awards/2021/Ultra1.png'
        }
      ],
      2020: [
        {
          title: t('P_AWARDS.CARDS2020.CARD-1.TITLE'),
          src: '/v2/awards/2020/IfDesign.png'
        },
        {
          title: t('P_AWARDS.CARDS2020.CARD-2.TITLE'),
          src: '/v2/awards/2020/RedDot.png'
        },
        {
          title: t('P_AWARDS.CARDS2020.CARD-3.TITLE'),
          src: '/v2/awards/2020/GoodDesign.png'
        },
        {
          title: t('P_AWARDS.CARDS2020.CARD-4.TITLE'),
          src: '/v2/awards/2020/IspoAward.png'
        },
        {
          title: t('P_AWARDS.CARDS2020.CARD-5.TITLE'),
          src: '/v2/awards/2020/GermanInnovation.png'
        },
        {
          title: t('P_AWARDS.CARDS2020.CARD-6.TITLE'),
          src: '/v2/awards/2020/ADI.png'
        }
      ],
      2019: [
        {
          title: t('P_AWARDS.CARDS2019.CARD-1.TITLE'),
          src: '/v2/awards/2019/GoodDesign.png'
        },
        {
          title: t('P_AWARDS.CARDS2019.CARD-2.TITLE'),
          src: '/v2/awards/2019/PlusXAward.png'
        },
        {
          title: t('P_AWARDS.CARDS2019.CARD-3.TITLE'),
          src: '/v2/awards/2019/PlusXAward2.png'
        }
      ]
    }),
    []
  );

  const productReviews = useMemo(
    () => [
      {
        title: t('P_AWARDS.THEYSAY.CARD-1A.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-1A.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-1A.DESC'),
        src: '/v2/awards/products/coach.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-1B.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-1B.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-1B.DESC'),
        src: '/v2/awards/products/courir.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-1.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-1.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-1.DESC'),
        src: '/v2/awards/products/1.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-2.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-2.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-2.DESC'),
        src: '/v2/awards/products/2.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-3.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-3.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-3.DESC'),
        src: '/v2/awards/products/3.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-4.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-4.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-4.DESC'),
        src: '/v2/awards/products/4.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-5.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-5.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-5.DESC'),
        src: '/v2/awards/products/5.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-6.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-6.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-6.DESC'),
        src: '/v2/awards/products/6.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-7.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-7.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-7.DESC'),
        src: '/v2/awards/products/7.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-8.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-8.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-8.DESC'),
        src: '/v2/awards/products/8.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-9.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-9.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-9.DESC'),
        src: '/v2/awards/products/9.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-10.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-10.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-10.DESC'),
        src: '/v2/awards/products/10.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-11.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-11.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-11.DESC'),
        src: '/v2/awards/products/11.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-12.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-12.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-12.DESC'),
        src: '/v2/awards/products/12.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-13.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-13.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-13.DESC'),
        src: '/v2/awards/products/13.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-14.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-14.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-14.DESC'),
        src: '/v2/awards/products/14.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-15.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-15.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-15.DESC'),
        src: '/v2/awards/products/15.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-16.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-16.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-16.DESC'),
        src: '/v2/awards/products/16.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-17.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-17.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-17.DESC'),
        src: '/v2/awards/products/17.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-18.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-18.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-18.DESC'),
        src: '/v2/awards/products/18.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-19.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-19.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-19.DESC'),
        src: '/v2/awards/products/19.png'
      },
      {
        title: t('P_AWARDS.THEYSAY.CARD-20.TITLE'),
        prod: t('P_AWARDS.THEYSAY.CARD-20.PROD'),
        desc: t('P_AWARDS.THEYSAY.CARD-20.DESC'),
        src: '/v2/awards/products/20.png'
      }
    ],
    []
  );

  return (
    <div>
      <MyHead />

      <div className="relative section full bigspace">
        <Image
          src="/v2/awards/hero-1.jpg"
          alt=""
          width={0}
          height={0}
          priority
          sizes="100vw"
          className="absolute top-0 left-0 object-cover object-center w-full h-full"
        />
        <div className="relative text-white section-wrapper">
          <div className="grid grid-cols-12 gap-8 md:gap-12 xl:gap-20">
            <div className="col-span-12 md:col-span-8">
              <div className="h2">{t('P_AWARDS.SECTION-1.TITLE')}</div>
              <div className="mt-4 uppercase tracking-uyn md:text-xl opacity-80">
                {t('P_AWARDS.SECTION-1.DESC')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative section">
        <div className="relative section-wrapper">
          <div className="h5 max-w-[960px]">
            {t('P_AWARDS.SECTION-1.ADDITIONAL')}
          </div>
        </div>
      </div>

      {map(
        orderBy(entries(awards), ([year]) => year, 'desc'),
        ([year, awards]) => (
          <section key={year} className="section full">
            <div className="relative section-wrapper">
              <div className="mb-6 h2">{year}</div>
            </div>
            <Swiper
              wrapperTag="ul"
              slidesPerView={2.45}
              spaceBetween={24}
              className="px-6 md:px-10 xl:px-16 swiperScrollbar"
              modules={[Scrollbar, Navigation]}
              navigation={true}
              scrollbar={{
                hide: false
              }}
              breakpoints={{
                768: {
                  slidesPerView: 2.2
                },
                1024: {
                  slidesPerView: 4
                },
                1280: {
                  slidesPerView: 6
                }
              }}
            >
              {awards.map((award, idx) => (
                <SwiperSlide
                  key={idx}
                  tag="li"
                  className="space-y-3 overflow-hidden"
                >
                  <Image
                    src={award.src}
                    alt={award.title}
                    width={0}
                    height={0}
                    sizes="100vw"
                    className="aspect-square w-full max-w-[160px]"
                  />

                  <p className="text-sm md:text-base">{award.title}</p>
                </SwiperSlide>
              ))}
            </Swiper>
          </section>
        )
      )}

      <div className="relative section full bg-sand-50">
        <div className="relative text-center section-wrapper">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 md:col-span-8 md:col-start-3">
              <div className="h2">{t('P_AWARDS.THEYSAY.TITLE')}</div>
              <div className="mt-4 uppercase tracking-uyn md:text-xl opacity-80">
                {t('P_AWARDS.THEYSAY.DESC')}
              </div>
            </div>

            <div className="col-span-12 mt-8">
              <Swiper
                wrapperTag="ul"
                slidesPerView={1}
                spaceBetween={24}
                navigation={true}
                modules={[Navigation]}
              >
                {productReviews.map((card, idx) => (
                  <SwiperSlide key={idx} tag="li" className="overflow-hidden">
                    <Image
                      src={card.src}
                      alt=""
                      width={0}
                      height={0}
                      sizes="100vw"
                      className="w-full max-w-[780px] mx-auto"
                    />

                    <div className="pt-6 space-y-4">
                      <div className="h3">{card.title}</div>
                      <div className="text-xl uppercase md:text-3xl opacity-40">
                        {card.prod}
                      </div>
                      <div className="md:text-xl text-lg opacity-40 mx-auto max-w-[860px]">
                        {card.desc}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>

      <StaticPagesCards />
    </div>
  );
};

export default AwardsPage;
